export const STORAGE_NAME_POSITION = 'suitabel_store_position'
